import React,{useEffect} from 'react';
import Slider from './../../components/Home/Slider.js';
import MainContent from './../../components/Home/MainContent.js';
import Box from './../../components/Box';


function Home(props) {
  

    
    
    return (
        <>
            <Slider data={props.data.sliders} />
            <Box data={props.data.data.box} custom_design={props.custom_design} />
            <MainContent custom_design={props.custom_design}  data={props.data.data.content}  language={props.data.data.language} />
        </>
    );
}
export default Home;
